import TwoColumnPageContainer, {
  PageNav,
  NavItem,
} from 'components/two-column-responsive-page-container'
import BackLink from 'shared/back-link'
import { useLocation, Outlet } from 'react-router-dom-v5-compat'
import { useEffect } from 'react'

import {
  shareRegistryInsertCardsPath,
  shareRegistryLinkPath,
  shareRegistryPath as indexPath,
} from 'lib/urls'

const ShareRegistryPage = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0)
    }
  }, [pathname])

  return (
    <TwoColumnPageContainer
      title="Share Registry"
      mobileBack={<BackLink to={indexPath}>Back to Share</BackLink>}
      mobileHideMenu={pathname != indexPath}
      mobileHideContent={pathname == indexPath}
    >
      <PageNav>
        <NavItem
          active={pathname == shareRegistryLinkPath || pathname == indexPath}
          path={shareRegistryLinkPath}
        >
          Registry Link
        </NavItem>
        <NavItem
          active={pathname == shareRegistryInsertCardsPath}
          path={shareRegistryInsertCardsPath}
        >
          Free Insert Cards
        </NavItem>
      </PageNav>
      <Outlet />
    </TwoColumnPageContainer>
  )
}

export default ShareRegistryPage
